import {
    API_DEACTIVATE_ACCOUNT,
    API_PROCESS_VISITOR,
} from '../../constants/endpoints'
import { controller } from '../../utilities/abortController'
import { EdgeApiResponse, fetchStatusResolver } from './utilities'

type ProcessVisitorResult = {
    age_check_required: 0 | 1
    age_check_services?: {
        [key: string]: {
            enabled: 0 | 1
            perks?: Array<string>
            url?: string
            country_code?: string
            region?: string
        }
    }
    cookies: Array<Array<number | string>>
    get: Array<any>
    maintenance_mode: 0 | 1
    query_string: any
    redirection: string
    user?: {
        id: number
        username: string
        access_level: number
        tokens: number
        token_storage: number
        rewards_points: number
        token: string
        status: string
        emails: Array<{
            email: string
            status: string
            used_for: Array<any>
        }>
    }
}

export async function fetchEntryInformation() {
    const endpoint = API_PROCESS_VISITOR
    const response = await fetch(`${endpoint}?get_user_data=1&client_id=1101`, {
        credentials: 'include',
        signal: controller.signal,
    })
    return (await response.json()) as EdgeApiResponse<ProcessVisitorResult>
}

type DeactivateAccountResult = null

export async function deactivateAccount(token: string, password: string) {
    const response = await fetch(API_DEACTIVATE_ACCOUNT, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
        signal: controller.signal,
    }).then(fetchStatusResolver)
    const { err, errmsg } =
        (await response.json()) as EdgeApiResponse<DeactivateAccountResult>
    if (err !== 0) {
        throw new Error(`[deactivateAccount] failed, ${err}, ${errmsg}`)
    }
}
